import React, { useState, useEffect } from 'react';

import { TextProps, TextPropsSchema } from '@usewaypoint/block-text';

import BaseSidebarPanel, { SectionHeader } from './helpers/BaseSidebarPanel';
import SingleStylePropertyPanel from './helpers/style-inputs/SingleStylePropertyPanel';
import { Separator } from '@/components/ui/separator';

type TextSidebarPanelProps = {
  data: TextProps;
  setData: (v: TextProps) => void;
};

export default function TextSidebarPanel({ data, setData }: TextSidebarPanelProps) {
  const [, setErrors] = useState<Zod.ZodError | null>(null);

  const updateData = (d: unknown) => {
    const res = TextPropsSchema.safeParse(d);
    if (res.success) {
      setData(res.data);
      setErrors(null);
    } else {
      setErrors(res.error);
    }
  };

  // Always enable markdown mode for rich text editing
  useEffect(() => {
    if (!data.props?.markdown) {
      updateData({ ...data, props: { ...data.props, markdown: true } });
    }
  }, []);

  return (
    <BaseSidebarPanel title="Text block">
      {/* APPEARANCE SECTION */}
      <div className="space-y-4">
        <SectionHeader>Appearance</SectionHeader>
        <div className="space-y-3">
          <SingleStylePropertyPanel
            name="color"
            value={data.style || {}}
            onChange={(style) => updateData({ ...data, style })}
          />
          <SingleStylePropertyPanel
            name="backgroundColor"
            value={data.style || {}}
            onChange={(style) => updateData({ ...data, style })}
          />
        </div>
      </div>

      <Separator className="my-6" />

      {/* TYPOGRAPHY SECTION */}
      <div className="space-y-4">
        <SectionHeader>Typography</SectionHeader>
        <div className="space-y-3">
          <SingleStylePropertyPanel
            name="fontFamily"
            value={data.style || {}}
            onChange={(style) => updateData({ ...data, style })}
          />
          <SingleStylePropertyPanel
            name="fontSize"
            value={data.style || {}}
            onChange={(style) => updateData({ ...data, style })}
          />
        </div>
      </div>

      <Separator className="my-6" />

      {/* LAYOUT SECTION */}
      <div className="space-y-4">
        <SectionHeader>Layout</SectionHeader>
        <div className="space-y-3">
          <SingleStylePropertyPanel
            name="textAlign"
            value={data.style || {}}
            onChange={(style) => updateData({ ...data, style })}
          />
          <SingleStylePropertyPanel
            name="padding"
            value={data.style || {}}
            onChange={(style) => updateData({ ...data, style })}
          />
        </div>
      </div>
    </BaseSidebarPanel>
  );
}
